import React, { useState, useEffect } from 'react'
import { createStore } from "../store/state"
import { Navigate, Outlet } from 'react-router-dom'
import Header from '../components/Header'
import { IoMenu } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import LoginNav from '../components/LoginNav';
import Footer from '../components/Footer';
import { setAuthToken } from '../controller/api';

export default function AdminLayout() {
    const [isActive, setIsActive] = useState(false);

    const { user } = createStore((state) => state)

    const menuStyle = isActive ? "menu open" : "menu";
    setAuthToken(user?.token || "")

    return !user ? <Navigate to="/overview" replace={true} /> : <>
        <Header />
        <nav>
            <div className='res-menu'>
                <span>Menu</span>
                <div
                    className="hamburger"
                    onClick={() => setIsActive((action) => !action)}
                >
                    {isActive ? <IoClose /> : <IoMenu />}
                </div>
            </div>
            <ul className={menuStyle} onClick={() => setIsActive((action) => !action)}>
                <LoginNav />
            </ul>
        </nav>
        <Outlet />
        <Footer />
    </>
}
